import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useFreeTrialContext } from '@/contexts/FreeTrialContext';

/**
 * 桥接组件：将免费试用信息传递给AuthContext
 * 这样AuthContext就能访问免费试用的token状态
 */
export const AuthFreeTrialBridge: React.FC = () => {
  const { setFreeTrialInfo } = useAuth();
  const { isInFreeTrial, freeTrialStatus, updateTokenUsage, clearFreeTrial } = useFreeTrialContext();

  useEffect(() => {
    // 将免费试用信息传递给AuthContext
    if (isInFreeTrial && freeTrialStatus) {
      setFreeTrialInfo({
        isInFreeTrial: true,
        remainingTokens: freeTrialStatus.remainingTokens,
        updateFreeTrialTokens: updateTokenUsage,
        clearFreeTrial: clearFreeTrial,
      });
    } else {
      setFreeTrialInfo(null);
    }
  }, [isInFreeTrial, freeTrialStatus, updateTokenUsage, clearFreeTrial, setFreeTrialInfo]);

  // 这个组件不渲染任何UI，只是负责数据桥接
  return null;
}; 